import React, { useState, useEffect, useRef } from "react";
import { Checkbox, CheckboxGroup, Button } from "rsuite";
import OpportunitySliderExp from "./opportunitySliderexp";
import { useDispatch } from "react-redux";
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import { submitOpportunities } from "../../queries/apiQueries";

interface PeerVendor {
	master_vendor_name: string;
	rebate_category: string;
	rebate_base: number;
	spend: number;
	selectedPeers: boolean;
	L1: string;
	[key: string]: any;
}

interface PeerVendorRebate {
	[key: string]: PeerVendor[];
}

interface SelectedVendorRebate {
	master_vendor_name: string;
	rebate_category: string;
	rebate_base: number;
	rate?: string;
	[key: string]: any;
}

interface PeerData {
	yellowPivotValue: number;
	selectedVendorRebate: SelectedVendorRebate[];
	bestRebateData: SelectedVendorRebate;
	peerVendorRebate: PeerVendorRebate;
	[key: string]: any;
}

interface BenchmarkData {
	master_vendor_name: string;
	rebate_category: string;
	rebate_base: number;
	rate?: string;
	[key: string]: any;
}

interface PeerBenchmarksProps {
	peerDatas: PeerData;
	updateBestPeerEffectiveRebate: (rate: number) => void;
	updateReset: (isReset: boolean, action?: string, rate?: number) => void;
	isResetAvailable: boolean;
}

const PeerBenchmarksExp = (props: any) => {
	const dispatch = useDispatch<any>();
	const [slider, setSlider] = useState({ sliderLeft: 0, sliderRight: 122.5 });
	const [value, setValue] = useState<any>([]);
	const [benchmarkData, setBenchmarkData] = useState<any>({
		master_vendor_name: "",
		rebate_category: "",
		rebate_base: 0,
		"0.00%": 0,
		"80.00%": 0,
		"85.00%": 0,
		"90.00%": 0,
		"95.00%": 0,
		"100.00%": 0,
		"102.50%": 0,
		"105.00%": 0,
		"107.50%": 0,
		"110.00%": 0,
		"112.50%": 0,
		"115.00%": 0,
		"117.50%": 0,
		"120.00%": 0,
		"122.50%": 0,
	});

	const csvLinkRef = useRef<any>(null);
	const peerDatas = props?.peerDatas;
	const points = [100, 102.5, 105, 107.5, 110, 112.5, 115, 117.5, 120, 122.5];

	const calculateRate = (rebateData: BenchmarkData): string => {
		const leftPivot = peerDatas.yellowPivotValue * 100;
		if (leftPivot < 80) {
			return (
				((rebateData["0.00%"] + rebateData.rebate_base) * 100).toFixed(
					2
				) + "%"
			);
		} else if (leftPivot >= 80 && leftPivot < 85) {
			return (
				((rebateData["80.00%"] + rebateData.rebate_base) * 100).toFixed(
					2
				) + "%"
			);
		} else if (leftPivot >= 85 && leftPivot < 90) {
			return (
				((rebateData["85.00%"] + rebateData.rebate_base) * 100).toFixed(
					2
				) + "%"
			);
		} else if (leftPivot >= 90 && leftPivot < 95) {
			return (
				((rebateData["90.00%"] + rebateData.rebate_base) * 100).toFixed(
					2
				) + "%"
			);
		} else if (leftPivot >= 95 && leftPivot < 100) {
			return (
				((rebateData["95.00%"] + rebateData.rebate_base) * 100).toFixed(
					2
				) + "%"
			);
		} else if (leftPivot >= 100 && leftPivot < 102.5) {
			return (
				(
					(rebateData["100.00%"] + rebateData.rebate_base) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 102.5 && leftPivot < 105) {
			return (
				(
					(rebateData["102.50%"] + rebateData.rebate_base) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 105 && leftPivot < 107.5) {
			return (
				(
					(rebateData["105.00%"] + rebateData.rebate_base) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 107.5 && leftPivot < 110) {
			return (
				(
					(rebateData["107.50%"] + rebateData.rebate_base) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 110 && leftPivot < 112.5) {
			return (
				(
					(rebateData["110.00%"] + rebateData.rebate_base) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 112.5 && leftPivot < 115) {
			return (
				(
					(rebateData["112.50%"] + rebateData.rebate_base) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 115 && leftPivot < 117.5) {
			return (
				(
					(rebateData["115.00%"] + rebateData.rebate_base) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 117.5 && leftPivot < 120) {
			return (
				(
					(rebateData["117.50%"] + rebateData.rebate_base) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 120 && leftPivot < 122.5) {
			return (
				(
					(rebateData["120.00%"] + rebateData.rebate_base) *
					100
				).toFixed(2) + "%"
			);
		} else {
			return (
				(
					(rebateData["122.50%"] + rebateData.rebate_base) *
					100
				).toFixed(2) + "%"
			);
		}
	};

	const handleSubmit = async () => {
		let peerVendorList: any = {};
		let selectedCategoryList: any = [];

		if (value.length > 0) {
			value.map((item: any) => {
				const category: string = item.split("_")[0];
				if (!selectedCategoryList.includes(category)) {
					selectedCategoryList = [...selectedCategoryList, category];
				}
				const peerVendorData = peerDatas.peerVendorRebate;
				const vendorItemData =
					peerVendorData[category][item.split("_")[1]];
				if (peerVendorList[category]) {
					peerVendorList[category] = [
						...peerVendorList[category],
						vendorItemData.master_vendor_name,
					];
				} else {
					peerVendorList[category] = [
						vendorItemData.master_vendor_name,
					];
				}
				// peerVendorList?.push(vendorItemData?.master_vendor_name)
				return null;
			});
		}

		Object.keys(peerDatas.peerVendorRebate).forEach((key) => {
			if (!selectedCategoryList.includes(key)) {
				peerVendorList[key] = {};
			}
		});

		let payloadObject = {
			vendor_name: peerDatas.selectedVendorRebate[0]?.master_vendor_name,
			bestRebate: calculateRate(benchmarkData),
			isUpdated: 1,
			peerVendors: peerVendorList,
		};
		let res = await dispatch(submitOpportunities(payloadObject));
		// props.updateBestPeerEffectiveRebate(Number(calculateRate(benchmarkData)), false);
		props.updateReset(false, "save", Number(calculateRate(benchmarkData)));
	};

	const handleReset = () => {
		props.updateReset(false, "reset");
	};

	const changeTriggered = () => {
		props.updateReset(true);
	};

	const highlightItem = (item: any, point: any, vendorItemObj: any) => {
		let categoryHighestSelected: any = {};
		let temp: any = {};
		let rebateAvailablePercent = [
			"0.00%",
			"80.00%",
			"85.00%",
			"90.00%",
			"95.00%",
			"100.00%",
			"102.50%",
			"105.00%",
			"107.50%",
			"110.00%",
			"112.50%",
			"115.00%",
			"117.50%",
			"120.00%",
			"122.50%",
			"rebate_base",
		];
		let selectedItems = value.sort();

		selectedItems.map((item: any, index: any) => {
			const category: string = item.split("_")[0];
			const peerVendorData = peerDatas.peerVendorRebate;
			const vendorItemData = peerVendorData[category][item.split("_")[1]];

			if (index === 0) {
				temp = {
					master_vendor_name: vendorItemData["master_vendor_name"],
					rebate_category: vendorItemData["rebate_category"],
					rebate_base: vendorItemData["rebate_base"],
					spend: vendorItemData["spend"],
					"0.00%": vendorItemData["0.00%"],
					"80.00%": vendorItemData["80.00%"],
					"85.00%": vendorItemData["85.00%"],
					"90.00%": vendorItemData["90.00%"],
					"95.00%": vendorItemData["95.00%"],
					"100.00%": vendorItemData["100.00%"],
					"102.50%": vendorItemData["102.50%"],
					"105.00%": vendorItemData["105.00%"],
					"107.50%": vendorItemData["107.50%"],
					"110.00%": vendorItemData["110.00%"],
					"112.50%": vendorItemData["112.50%"],
					"115.00%": vendorItemData["115.00%"],
					"117.50%": vendorItemData["117.50%"],
					"120.00%": vendorItemData["120.00%"],
					"122.50%": vendorItemData["122.50%"],
					category: category,
				};
				categoryHighestSelected[category] = temp;
			} else if (temp.category === category) {
				rebateAvailablePercent.forEach((item: string) => {
					// Ensure vendorItemData and temp are defined and have the item property
					const vendorValue = vendorItemData
						? vendorItemData[item]
						: undefined;
					const tempValue = temp ? temp[item] : undefined;

					// Use Math.max only if vendorValue is defined, otherwise default to tempValue
					temp = {
						...temp,
						[item]:
							vendorValue !== undefined && tempValue !== undefined
								? Math.max(vendorValue, tempValue)
								: vendorValue !== undefined
								? vendorValue
								: tempValue !== undefined
								? tempValue
								: 0, // Default to 0 if both are undefined
					};
				});
				categoryHighestSelected[category] = temp;
			} else {
				temp = {
					master_vendor_name: vendorItemData["master_vendor_name"],
					rebate_category: vendorItemData["rebate_category"],
					rebate_base: vendorItemData["rebate_base"],
					spend: vendorItemData["spend"],
					"0.00%": vendorItemData["0.00%"],
					"80.00%": vendorItemData["80.00%"],
					"85.00%": vendorItemData["85.00%"],
					"90.00%": vendorItemData["90.00%"],
					"95.00%": vendorItemData["95.00%"],
					"100.00%": vendorItemData["100.00%"],
					"102.50%": vendorItemData["102.50%"],
					"105.00%": vendorItemData["105.00%"],
					"107.50%": vendorItemData["107.50%"],
					"110.00%": vendorItemData["110.00%"],
					"112.50%": vendorItemData["112.50%"],
					"115.00%": vendorItemData["115.00%"],
					"117.50%": vendorItemData["117.50%"],
					"120.00%": vendorItemData["120.00%"],
					"122.50%": vendorItemData["122.50%"],
					category: category,
				};
				categoryHighestSelected[category] = temp;
			}
		});

		if (value.includes(`${vendorItemObj.L1}_${item}`)) {
			let vendorValue: any;
			let categoryHighestValue: any;
			let benchmarkValue: any;
			let selectedVendorValue: any;
			if (point === "rebate_base") {
				vendorValue = Number(`${vendorItemObj?.[point] * 100}`).toFixed(
					2
				);

				categoryHighestValue = Number(
					`${
						categoryHighestSelected[vendorItemObj.L1]?.[point] * 100
					}`
				).toFixed(2);

				benchmarkValue = Number(
					`${benchmarkData?.[point] * 100}`
				).toFixed(2);

				selectedVendorValue = Number(
					`${peerDatas.selectedVendorRebate[0]?.[point] * 100}`
				).toFixed(2);
			} else {
				vendorValue = Number(
					`${vendorItemObj?.[`${point.toFixed(2)}%`] * 100}`
				).toFixed(2);
				categoryHighestValue = Number(
					`${
						categoryHighestSelected[vendorItemObj.L1]?.[
							`${point.toFixed(2)}%`
						] * 100
					}`
				).toFixed(2);
				benchmarkValue = Number(
					`${benchmarkData?.[`${point.toFixed(2)}%`] * 100}`
				).toFixed(2);
				selectedVendorValue = Number(
					`${
						peerDatas.selectedVendorRebate[0]?.[
							`${point.toFixed(2)}%`
						] * 100
					}`
				).toFixed(2);
			}

			if (selectedVendorValue < benchmarkValue) {
				if (vendorValue === categoryHighestValue) {
					return true;
				} else {
					return false;
				}
			} else if (
				vendorValue === benchmarkValue &&
				selectedVendorValue !== vendorValue
			) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	};

	const prepareExportData = () => {
		const formatRebateValues = (item: any) => {
			const formattedItem: any = {
				Category: item.L1 || "NA",
				Supplier: item.master_vendor_name,
				"Rebate Category": item.rebate_category,
			};

			// Add other fields
			Object.keys(item).forEach((key) => {
				if (
					key !== "master_vendor_name" &&
					key !== "rebate_category" &&
					key !== "spend" &&
					key !== "L1" &&
					key !== "rate"
				) {
					formattedItem[key] = `${(Number(item[key]) * 100).toFixed(
						2
					)}%`;
				}
			});

			// Add the rate at the end
			formattedItem.rate = item.rate || "NA";

			return formattedItem;
		};

		let exportData: any[] = [];

		const selectedVendorWithRate = {
			...peerDatas.selectedVendorRebate[0],
			rate: calculateRate(peerDatas.selectedVendorRebate[0]),
		};
		exportData.push(
			formatRebateValues({ ...selectedVendorWithRate, L1: "Selected" })
		);

		const bestRebateWithRate = {
			...peerDatas.bestRebateData,
			master_vendor_name: "Best Benchmark",
			rate: calculateRate(peerDatas.bestRebateData),
		};
		exportData.push(
			formatRebateValues({ ...bestRebateWithRate, L1: "Best Benchmark" })
		);

		Object.keys(peerDatas.peerVendorRebate).forEach((key) => {
			peerDatas.peerVendorRebate[key].forEach((vendor: any) => {
				if (vendor.selectedPeers) {
					exportData.push(formatRebateValues(vendor));
				}
			});
		});

		return exportData;
	};

	const csvHeaders = [
		{ label: "Category", key: "Category" },
		{ label: "Supplier", key: "Supplier" },
		{ label: "Rebate Category", key: "Rebate Category" },
		{ label: "Rebate Base", key: "rebate_base" },
		{ label: "0.00%", key: "0.00%" },
		{ label: "80.00%", key: "80.00%" },
		{ label: "85.00%", key: "85.00%" },
		{ label: "90.00%", key: "90.00%" },
		{ label: "95.00%", key: "95.00%" },
		{ label: "100.00%", key: "100.00%" },
		{ label: "102.50%", key: "102.50%" },
		{ label: "105.00%", key: "105.00%" },
		{ label: "107.50%", key: "107.50%" },
		{ label: "110.00%", key: "110.00%" },
		{ label: "112.50%", key: "112.50%" },
		{ label: "115.00%", key: "115.00%" },
		{ label: "117.50%", key: "117.50%" },
		{ label: "120.00%", key: "120.00%" },
		{ label: "122.50%", key: "122.50%" },
		{ label: "Rate", key: "rate" },
	];

	const exportData = () => {
		if (csvLinkRef.current?.link) {
			csvLinkRef.current.link.click();
		}
	};

	useEffect(() => {
		let defaultSelected: string[] = [];
		Object.keys(peerDatas.peerVendorRebate).forEach((key) => {
			peerDatas.peerVendorRebate[key].forEach(
				(item: PeerVendor, index: number) => {
					if (item.selectedPeers) {
						defaultSelected.push(`${item.L1}_${index}`);
					}
				}
			);
		});
		setValue(defaultSelected);
	}, [props.peerDatas]);

	useEffect(() => {
		let temp: any = {};
		let peersRebate: any = {};
		let finalRebate: any = {
			master_vendor_name: "",
			rebate_category: "",
			rebate_base: 0,
			"0.00%": 0,
			"80.00%": 0,
			"85.00%": 0,
			"90.00%": 0,
			"95.00%": 0,
			"100.00%": 0,
			"102.50%": 0,
			"105.00%": 0,
			"107.50%": 0,
			"110.00%": 0,
			"112.50%": 0,
			"115.00%": 0,
			"117.50%": 0,
			"120.00%": 0,
			"122.50%": 0,
		};
		let rebateAvailablePercent = [
			"0.00%",
			"80.00%",
			"85.00%",
			"90.00%",
			"95.00%",
			"100.00%",
			"102.50%",
			"105.00%",
			"107.50%",
			"110.00%",
			"112.50%",
			"115.00%",
			"117.50%",
			"120.00%",
			"122.50%",
			"rebate_base",
		];
		let selectedCategoryList: string[] = [];

		if (value.length > 0) {
			console.log(value, "value");
			const selectedItems = [...value].sort();
			console.log(selectedItems, "selected");
			selectedItems.forEach((item: string) => {
				const vendor = item.split("_")[0];
				if (!selectedCategoryList.includes(vendor)) {
					selectedCategoryList.push(vendor);
				}

				const vendorItemData =
					peerDatas.peerVendorRebate[vendor][
						parseInt(item.split("_")[1])
					];
				if (Object.keys(temp).length === 0) {
					temp = {
						master_vendor_name: vendorItemData.master_vendor_name,
						rebate_category: vendorItemData.rebate_category,
						rebate_base: vendorItemData.rebate_base,
						spend: vendorItemData.spend,
						...Object.fromEntries(
							rebateAvailablePercent.map((key) => [
								key,
								vendorItemData[key],
							])
						),
						vendor_name: vendor,
					};
					peersRebate[vendor] = temp;
				} else if (temp.vendor_name === vendor) {
					rebateAvailablePercent.forEach((key) => {
						const vendorValue = Number(vendorItemData[key]);
						const tempValue = Number(temp[key]);
						temp[key] = Math.max(vendorValue, tempValue);
					});
					peersRebate[vendor] = temp;
				} else {
					temp = {
						master_vendor_name: vendorItemData.master_vendor_name,
						rebate_category: vendorItemData.rebate_category,
						rebate_base: vendorItemData.rebate_base,
						spend: vendorItemData.spend,
						...Object.fromEntries(
							rebateAvailablePercent.map((key) => [
								key,
								vendorItemData[key],
							])
						),
						vendor_name: vendor,
					};
					peersRebate[vendor] = temp;
				}
			});

			let spendTotal = 0;

			Object.keys(peersRebate).forEach((key) => {
				rebateAvailablePercent.forEach((item) => {
					if (item === "rebate_base") {
						peersRebate[key][item] =
							peersRebate[key][item] >
							peerDatas.selectedVendorRebate[0]?.rebate_base
								? peersRebate[key][item]
								: peerDatas.selectedVendorRebate[0]
										?.rebate_base;
					}
					finalRebate[item] +=
						peersRebate[key][item] * peersRebate[key].spend;
				});
			});

			Object.keys(peerDatas.peerVendorRebate).forEach((key) => {
				if (!selectedCategoryList.includes(key)) {
					rebateAvailablePercent.forEach((item) => {
						finalRebate[item] +=
							peerDatas.selectedVendorRebate[0][item] *
							peerDatas.peerVendorRebate[key][0].spend;
					});
				}
				spendTotal += peerDatas.peerVendorRebate[key][0].spend;
			});

			rebateAvailablePercent.forEach((item) => {
				finalRebate[item] /= spendTotal;
				if (item === "rebate_base") {
					console.log(
						finalRebate?.rebate_base,
						Math.max(
							peerDatas.selectedVendorRebate[0][item],
							finalRebate[item]
						),
						peerDatas.selectedVendorRebate[0][item],
						finalRebate[item],
						"base"
					);
				}
				finalRebate[item] = Math.max(
					peerDatas.selectedVendorRebate[0][item],
					finalRebate[item]
				);
			});

			setBenchmarkData(finalRebate);
		} else {
			setBenchmarkData(peerDatas.selectedVendorRebate[0]);
		}
		props.updateBestPeerEffectiveRebate(
			parseFloat(calculateRate(finalRebate))
		);
	}, [value]);

	console.log(benchmarkData, "benchmark");

	return (
		<div className="peer-container-main gap-y-2 m-2">
			<div className="graphBox h-[48%]">
				<div className="spend-growth-wrapper">
					<div className="common-table-header-row">
						<div className="common-table-header">
							{" "}
							Spend Growth % and Rebate Tiers{" "}
						</div>
						<div className="flex gap-x-[1.8vh] not-italic pr-[1vh] ">
							<FileDownloadIcon
								color="black"
								className="text-[1.4vw]"
								onClick={exportData}
							/>
							<CSVLink
								ref={csvLinkRef}
								data={prepareExportData()}
								headers={csvHeaders}
								filename="peer_benchmarks.csv"
								className="hidden"
								target="_blank"
							/>
						</div>
					</div>
					<OpportunitySliderExp
						leftPivot={peerDatas.yellowPivotValue * 100}
						rightPivot={slider.sliderRight}
						rebate={peerDatas.selectedVendorRebate[0]}
						benchmark={benchmarkData}
					/>
				</div>
			</div>
			<div className="graphBox h-[50%]">
				<div className="benchmarkdiv ">
					<div className="common-table-header-row">
						<div className="common-table-header">
							Category wise Peer Benchmarks for{" "}
							{
								peerDatas.selectedVendorRebate[0]
									?.master_vendor_name
							}
						</div>
						<div className="flex justify-center gap-x-2">
							<Button
								className="submit-button mb-2"
								onClick={handleSubmit}
							>
								Submit Changes
							</Button>
							{props.isResetAvailable && (
								<Button
									className="reset-button mb-2"
									onClick={handleReset}
								>
									Reset
								</Button>
							)}
						</div>
					</div>
					<div className="peer-benchmark-wrapper ">
						{Object.keys(peerDatas.peerVendorRebate).map(
							(d, index) => (
								<div
									key={index}
									id={peerDatas.peerVendorRebate[d][0].L1}
									className="mb-4 pb-4 category_wrapper"
								>
									<div className="peer-heading benchmark-title font-medium">
										{peerDatas.peerVendorRebate[d][0].L1}
									</div>
									<div
										className={`flex flex-col peer-items-wrapper ${
											Object.keys(
												peerDatas.peerVendorRebate
											).length > 1
												? ""
												: "single-peer"
										}`}
									>
										<CheckboxGroup
											className="pl-3"
											value={value}
											onChange={(value: any) => {
												changeTriggered();
												setValue(value);
											}}
										>
											{peerDatas.peerVendorRebate[d].map(
												(
													vendor: PeerVendor,
													idx: number
												) => (
													<Checkbox
														key={idx}
														color="green"
														value={`${vendor.L1}_${idx}`}
													>
														<div className="peer-benchmark-item flex">
															<div className="vendor-sectionexp">
																{
																	vendor.master_vendor_name
																}
																<div
																	className={`${
																		highlightItem(
																			idx,
																			"rebate_base",
																			vendor
																		)
																			? "highlightValue"
																			: ""
																	}`}
																>
																	{(
																		vendor.rebate_base *
																		100
																	).toFixed(
																		2
																	)}
																	%
																</div>
															</div>
															<div className="rebate-tiersexp">
																<div className="rebate-tiers1exp">
																	{[
																		80, 85,
																		90, 95,
																	].map(
																		(
																			item,
																			i
																		) => (
																			<div
																				key={
																					i
																				}
																				className={`rebate-item ${
																					highlightItem(
																						idx,
																						item,
																						vendor
																					)
																						? "highlightValue"
																						: ""
																				}`}
																			>
																				{`${(
																					Number(
																						vendor[
																							`${item.toFixed(
																								2
																							)}%`
																						]
																					) *
																					100
																				).toFixed(
																					2
																				)}%`}
																			</div>
																		)
																	)}
																</div>
																<div className="rebate-tiers2exp">
																	{points.map(
																		(
																			item,
																			i
																		) => (
																			<div
																				key={
																					i
																				}
																				className={`rebate-item ${
																					highlightItem(
																						idx,
																						item,
																						vendor
																					)
																						? "highlightValue"
																						: ""
																				}`}
																			>
																				{![
																					82.5,
																					87.5,
																					92.5,
																					97.5,
																				].includes(
																					item
																				) &&
																					`${(
																						Number(
																							vendor[
																								`${item.toFixed(
																									2
																								)}%`
																							]
																						) *
																						100
																					).toFixed(
																						2
																					)}%`}
																			</div>
																		)
																	)}
																</div>
															</div>
															<div
																className="peer_rate"
																style={{
																	visibility:
																		"hidden",
																}}
															>
																4%
															</div>
														</div>
													</Checkbox>
												)
											)}
										</CheckboxGroup>
									</div>
								</div>
							)
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default PeerBenchmarksExp;
